import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { conversationStateReset, fetchConversation } from '../../features/aiProducts/aiProductsActions';
import PageLoading from '../../common/components/elements/PageLoading';
import StorageService from '../../services/StorageService';
import { AiProductsFormStyles, SidebarCard } from './AiProducts.styles';
import { CenteredDivTitle } from '../../common/components/CenteredPageTitle.styles';
import CenteredPageTitle from '../../common/components/CenteredPageTitle';
import NoMessagePlaceHolder from './components/NoMessagePlaceHolder';
import AiMessage from './components/AiMessage';
import HumanMessage from './components/HumanMessage';
import AnimatedStatus from './components/AnimatedStatus';
import DocumentUploadComponent from './components/DocumentUploadComponent';
import { Label } from '../../common/formInputs/styles/common';
import TextInputAi from './components/TextInputAi';
import { generalAlertError } from '../../common/utils/alerts';
import managementAxe from '../../services/axios-client/managementServisAxeClient';
import ProductAttachments from './components/ProductAttachments';

const Storage = new StorageService();
function AiProductChatShow() {
  const { threadId } = useParams();
  const {
    loading, conversation, messages, documents,
  } = useSelector((store) => store.aiProducts.conversation);
  const toBottomRef = useRef(null);
  const user = Storage.getUser();
  const [message, setMessage] = useState(null);
  const [sendingMessage, setSendingMessage] = useState(false);
  const [newMessages, setNewMessages] = useState([]);
  const collectsClientData = conversation?.product?.collects_client_data !== false;

  const sendMessage = async () => {
    if (message === null) {
      generalAlertError('Per inviare un messaggio devi scrivere qualcosa');
      return;
    }
    setNewMessages((prevMessages) => [...prevMessages, message]);
    const data = {
      message: message.message,
    };
    setMessage(null);
    setSendingMessage(true);
    const response = await managementAxe.post(`ai/product-agent/${threadId}`, data);

    if (response.status !== 200) {
      generalAlertError('Si è verificato un errore durante l\'invio del messaggio');
      setSendingMessage(false);
      return;
    }

    const aiMessage = {
      message: response.data.response.message,
      type: 'ai',
      created_at: new Date(),
    };
    setNewMessages((prevMessages) => [...prevMessages, aiMessage]);

    setSendingMessage(false);
  };

  useEffect(() => {
    fetchConversation(threadId);

    return () => {
      conversationStateReset();
    };
  }, [threadId]);

  useEffect(() => {
    if (toBottomRef.current) {
      toBottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, newMessages]);

  if (loading) {
    return <PageLoading />;
  }

  return (
    <AiProductsFormStyles>
      <CenteredDivTitle className="d-flex align-items-center justify-content-center gap-3">
        <CenteredPageTitle title="Chat With AI" />
      </CenteredDivTitle>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-7 col-xl-9">
          <div className="border border-1 rounded-3 p-2 d-flex flex-column" style={{ height: '100%', maxHeight: '400px', overflowY: 'auto' }}>
            <div className="w-100 mt-auto">
              {messages.length === 0 ? (
                <NoMessagePlaceHolder />
              ) : (
                messages.map((message, index) => {
                  if (message.type === 'ai') {
                    return <AiMessage key={index} message={message} />;
                  }
                  return <HumanMessage message={message} key={index} user={user} />;
                })
              )}
              {loading && (
                <AnimatedStatus />
              )}
              {(
                newMessages.map((message, index) => {
                  if (message.type === 'ai') {
                    return <AiMessage key={index} message={message} />;
                  }
                  return <HumanMessage message={message} key={index} user={user} />;
                })
              )}
              {sendingMessage && (
                <AnimatedStatus />
              )}
              <div ref={toBottomRef} className="pb-2" />
            </div>
          </div>
          <div className="mt-4 mx-auto">
            <div className="row">
              {conversation?.product?.documents.length > 0 && (
                <div className="col-12 mb-3">
                  <div className="row">
                    {conversation?.product?.documents.map((document, index) => (
                      <DocumentUploadComponent document={document} key={index} threadId={threadId} setUploadedDocuments={() => { }} uploadedDocuments={documents} />
                    ))}
                  </div>
                </div>
              )}
              <div className="col-12 mb-2">
                <Label>Domanda l'IA per il prodotto che hai neccessita.</Label>
              </div>
              <div className="col-12">
                <TextInputAi
                  placeholder="Esempio: Vorrei un preventivo per la casa del cliente Mario Rossi maschio nato il 17 aggosto 1990"
                  rows={3}
                  className="form-control"
                  name="aiQuestion"
                  id="aiQuestion"
                  value={message ? message.message : ''}
                  onChange={(e) => setMessage({
                    message: e.target.value,
                    type: 'human',
                    created_at: new Date(),
                  })}
                />
              </div>
              <div className="col-12 mt-2">
                <button type="button" onClick={() => sendMessage()} className="btn btn-success h-100 w-100 d-flex align-items-center justify-content-center gap-2 py-2">
                  <p className="m-0 fw-bold fs-6">Invia</p>
                  <FontAwesomeIcon icon={faPaperPlane} size="lg" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-5 col-xl-3 h-100">
          <div className="p-0 mt-2 ">
            <div
              className="px-1"
              style={{
                height: '100%', maxHeight: '600px', overflowY: 'auto', overflowX: 'hidden',
              }}
            >
              <div className="row">
                <ProductAttachments attachments={conversation?.product?.attachments} />
                <div className="col-sm-12 col-md-4 col-lg-12 col-xl-12">
                  <SidebarCard>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <h6 className="m-0 fw-bold sidebar-title">Documenti Richiesti</h6>
                      {conversation?.product?.documents.length > 0 && (
                        <span className="badge rounded-pill sidebar-count">{conversation.product.documents.length}</span>
                      )}
                    </div>
                    <ul className="list-unstyled m-0 d-grid gap-2">
                      {conversation?.product?.documents.map((document, index) => (
                        <li key={index} className="sidebar-item">
                          {document.name}
                        </li>
                      ))}
                      {conversation?.product?.documents.length === 0 && (
                        <li className="sidebar-empty">
                          Inizia la conversazione per vedere i documenti richiesti
                        </li>
                      )}
                    </ul>
                  </SidebarCard>
                </div>
                {collectsClientData && (
                  <>
                    <div className="col-sm-12 col-md-4 col-lg-12 col-xl-12">
                      <SidebarCard>
                        <h6 className="m-0 mb-2 fw-bold sidebar-title">Dati Richiesti</h6>
                        <ul className="list-unstyled m-0 d-grid gap-2">
                          {conversation.data && conversation.data.map((data, index) => (
                            <li key={index} className="sidebar-item">
                              {data.name}
                            </li>
                          ))}
                          {conversation.data && conversation.data.length === 0 && (
                            <li className="sidebar-empty">
                              Inizia la conversazione per vedere i dati richiesti
                            </li>
                          )}
                        </ul>
                      </SidebarCard>
                    </div>
                    <div className="col-sm-12 col-md-4 col-lg-12 col-xl-12">
                      <SidebarCard>
                        <h6 className="m-0 mb-2 fw-bold sidebar-title">Informazioni Cliente</h6>
                        <ul className="list-unstyled m-0 d-grid gap-2">
                          {conversation.client !== null && (
                            <>
                              <li className="sidebar-item">
                                {conversation?.client?.name ? `${conversation.client.name} ${conversation.client.surname}` : conversation.client.business_name}
                              </li>
                              {conversation?.client.birth_date && (
                                <li className="sidebar-item">
                                  {`Nato il ${conversation.client.birth_date}`}
                                </li>
                              )}
                            </>
                          )}
                          {conversation.client === null && (
                            <li className="sidebar-empty">
                              Inizia la conversazione per vedere i dati cliente
                            </li>
                          )}
                        </ul>
                      </SidebarCard>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AiProductsFormStyles>
  );
}

export default AiProductChatShow;
